import InformationSection from './InformationSection';

export default InformationSection;
